export default {
  navbar: {
    Home: "Startseite",
    Dashboard: "Dashboard",
    My: "Mein Bereich",
    Support: "Support",
    Projects: "Projekte",
    ProjectCount: "Projektanzahl",
    Admin: "Administrator",
    Library: "Bibliothek",
    ProjectList: "Projektliste",
    Profile: "Profil",
    SiteObservation: "Feststellungen vor Ort",
    GenerateReport: "Berichte erstellen",
    BaselineConfig: "Konfiguration der Ausgangsbasis",
    MonthlyBaseline: "Monatliche Ausgangsbasis",
    EquipmentSpecs: "Technische Gerätedaten",
    BaselinePreview: "Vorschau der Ausgangsbasis",
    Analysis: "Analyse",
    Menu: "Menü",
    Objective: "Zielsetzung",

    RetrofitSolution: "Modernisierungslösung",
    ExistingEqptSpecs: "Technische Daten der Bestandsgeräte",

    Baseline: "Ausgangsbasis",
    Proposed: "Vorgeschlagene Lösung",
    SetupOperatingCondition: "Betriebsbedingungen festlegen",
    DefineNewEquipment: "Neue Geräte definieren"
  },

  ctrl: {
    Login: "Anmelden",
    Logout: "Abmelden",
    Register: "Registrieren",
    ModifyPassword: "Passwort ändern",
    Language: "Sprache",
    UserGuide: "Benutzerhandbuch",
    UserSetting: "Benutzereinstellungen",
    Delete: "Löschen",
    Cancel: "Abbrechen",
    Edit: "Bearbeiten",
    Copy: "Kopieren",
    Paste: "Einfügen",
    Proceed: "Weiter",
    Save: "Speichern",
    Back: "Zurück",
    Next: "Weiter",
    Confirm: "Bestätigen",
    Close: "Schließen",
    Exit: "Beenden",
    All: "Alle",
    Clear: "Leeren",
    Yes: "Ja",
    No: "Nein",
    Template: "Vorlage",
    AddEquipment: "Gerät hinzufügen",
    DownloadReport: "Bericht herunterladen",
    MultiInput: "Mehrpunkteingabe",
    AddBaseline: "Ausgangsbasis hinzufügen",
    Estimate: "Schätzen",
    Calculate: "Berechnen",
    ViewDetail: "Details anzeigen",
    CollapseDetail: "Details einklappen",
    Generate: "Erstellen",
    Input: "Eingabe",
    Reconfigure: "Neu konfigurieren",
    Optimize: "Optimieren",
    CurrentYear: "Aktuelles Jahr",
    LastYear: "Letztes Jahr",
    NextYear: "Nächstes Jahr",
    Last12Months: "Letzte 12 Monate",
    Next12Months: "Nächste 12 Monate",
    selectClearAll: "Alles auswählen / Auswahl löschen",
    View: "Anzeigen"
  },

  label: {
    ProjectName: "Projektname",
    Multiple: "Mehrere",
    BuildVertical: "Gebäudenutzungsart",
    DataCollectionMont: "Monat der Datenerfassung",
    CurrencyLabel: "Währungsbezeichnung",
    TemperatureUnit: "Temperatureinheit",
    Unit: "Einheit",
    Time: "Zeit",
    Hour: "Stunde",
    Hours: "Stunden",
    Day: "Tag",
    Days: "Tage",
    Month: "Monat",
    Months: "Monate",
    Year: "Jahr",
    Years: "Jahre",

    ChillerType: "Flüssigkeitskühlertyp",
    PumpingConfiguration: "Pumpenkonfiguration",
    Primary: "Primär",

    RatedPower: "Nennleistung",
    RatedInputPower: "Nennleistungsaufnahme",
    RatedCoolingCapacity: "Nennkälteleistung",
    Frequency: "Frequenz",
    MaxHz: "Maximale Frequenz",
    MinHz: "Minimale Frequenz",
    RatedFrequency: "Nennfrequenz",
    MaxFrequency: "Obere Betriebsfrequenzgrenze",
    MinFrequency: "Untere Betriebsfrequenzgrenze",
    RatedHeatRejectionCapacity: "Nenn-Wärmeabfuhrleistung",

    VFD: "Frequenzumrichter (VFD)",
    VariableFrequencyDrive: "Frequenzumrichter",

    AssetLabels: "Anlagenkennzeichnungen",
    UnitNumber: "Anzahl der Geräte (#)",
    PumpType: "Pumpentyp",
    DateCommissioned: "Inbetriebnahmedatum",
    Degradation: "Alterungsfaktor",
    Brand: "Marke",
    Model: "Modell",
    Remarks: "Anmerkungen",

    RatedInputPower_100: "Nennleistungsaufnahme bei 100 % Last",
    RatedInputPower_100_ct: "Nennleistungsaufnahme bei 100 % Last je Kühlturm",

    RatedCoolingCapacity_100: "Nennkälteleistung bei 100 % Last",
    RatedHeatRejectionCapacity_100: "Nenn-Wärmeabfuhrleistung bei 100 % Last",

    DesignCondenserWaterEnteringTemp: "Auslegungs-Wassereintrittstemperatur am Verflüssiger",
    TotalCellPerCoolingTower: "Gesamtzahl der Zellen je Kühlturm",
    ActualCondenserWaterEnteringTemp: "Ist-Wassereintrittstemperatur am Verflüssiger",
    TotalCellPerDryCooler: "Gesamtzahl der Zellen je Trockenrückkühler",
    DryCoolerType: "Trockenrückkühlertyp",
    RatedCapacity: "Nennleistung",
    EnergyType: "Zugeführte Energie",

    BaselineName: "Name der Ausgangsbasis",
    ApplicableMonths: "Zutreffende Monate",

    DataTable: "Datentabelle",
    ChartView: "Diagrammansicht",
    CoolingLoad: "Kühllast",
    Total: "Gesamt",

    Observation: "Feststellung",
    Photo: "Foto",
    Maximum6: "Maximal 6",

    ChillerConfiguration: "Flüssigkeitskühlerkonfiguration",
    BoilerConfiguration: "Heizkesselkonfiguration",
    CoolingSystemConfiguration: "Kühlsystemkonfiguration",

    MaxHeatingCapacity: "Maximale Heizleistung im kältesten Monat",
    EffectiveCapacity: "Effektive Leistung im kältesten Monat",
    BoilerEfficiency: "Heizkesselwirkungsgrad",
    hotWaterTemp: "Erforderliche Heizwassereintrittstemperatur",

    EnergyCarbonIntensity: "CO₂-Emissionsfaktor des Energieträgers",
    FuelCalorificValue: "Heizwert des Brennstoffs (CV)",

    ZeroHeatingOAT: "Außentemperatur bei Heizlast null",
    MaxHeatingOAT: "Außentemperatur bei maximalem Wärmebedarf",
    DesiredHotWaterTemp: "Gewünschte Heizwassertemperatur",
    BoilerUtilizationColdestTemp: "Heizkesselauslastung bei niedrigster Temperatur",
    ColdestWater: "Niedrigste Wassereintrittstemperatur",

    WaterDemandPerDay: "Durchschnittlicher Wasserbedarf pro Person",
    UserNumber: "Anzahl der Nutzer",
    liters: "Liter",

    ChillerModel: "Flüssigkeitskühlermodell",
    RefChillerModel: "Referenz-Flüssigkeitskühlermodell",
    WeatherProfile: "Wetterprofil",
    EstimatePath: "Berechnungspfad",
    AvailableData: "Verfügbare Daten",
    CondenserWaterTempProfile: "Temperaturprofil des Kühlwassers des Verflüssigers",

    DesignCondenserSupplyTemp: "Auslegungs-Kühlwassereintrittstemperatur am Verflüssiger",
    DesignCondenserAirSupplyTemp: "Auslegungs-Lufteintrittstemperatur am Verflüssiger",
    DesignChilledWaterTemp: "Auslegungs-Kaltwassereintrittstemperatur",
    OutDoorDryBulbTemp: "Außenluft-Trockenkugeltemperatur",
    ChilledWaterSupplyTemp: "Kaltwassereintrittstemperatur",
    TowerApproachTemp: "Kühlturm-Kühlgrenzabstand",
    ActualChilledWaterSupplyTemp: "Ist-Kaltwassereintrittstemperatur",
    ActualCondenserSupplyTemp: "Ist-Kühlwassereintrittstemperatur am Verflüssiger",
    ActualCondenserAirSupplyTemp: "Ist-Lufteintrittstemperatur am Verflüssiger",
    MinCondenserWaterSupplyTemp: "Minimale Kühlwassereintrittstemperatur am Verflüssiger",
    DesignSourceWaterTemp: "Auslegungs-Wassereintrittstemperatur auf der Quellenseite",
    DesignSourceAirTemp: "Auslegungs-Lufteintrittstemperatur auf der Quellenseite",
    DesignHotWaterSupplyTemp: "Auslegungs-Heizwassereintrittstemperatur",

    ChillerRunningNumber: "Anzahl der derzeit betriebenen Flüssigkeitskühler",
    CoolingCapacityRange: "Kälteleistungsbereich",
    AllRightsReserved: "Alle Rechte vorbehalten.",

    From: "Von",
    To: "Bis",

    Cluster: "Gruppe",
    ClusterNum: "Anzahl der Gruppen",
    ClusterName: "Gruppenname",
    WeekPeriod: "Wochenabschnitt",
    AssociationMethod: "Zuordnungsmethode",

    MaxCoolingLoadBaseline: "Maximale Kühllast der Ausgangsbasis",
    MaxCoolingLoad: "Maximale Kühllast",
    AssociatedChiller: "Zugeordneter Flüssigkeitskühler",
    MaxRunningNumber: "Maximale Anzahl betriebener Geräte",
    Chiller: "Flüssigkeitskühler",
    AssociatedHeatPump: "Zugeordnete Wärmepumpe",

    RetrofitPreferences: "Modernisierungseinstellungen",

    CAPEX: "Investitionsausgaben (CAPEX; Projektpreis einschließlich Installation)",
    OverallProjectPrice: "Gesamtprojektpreis",
    USFXRate: "USD-Wechselkurs",

    Option: "Option",
    Solution: "Lösung",

    GeneralInfo: "Allgemeine Informationen",
    TechSpec: "Technische Spezifikation",
    PerformanceConditions: "Bedingungen der Leistungsbewertung",
    EcatPerformanceInput: "Eingabe der eCAT-Leistungsdaten",
    Capacity: "Leistung",
    CoolingCapacity: "Kälteleistung",
    SerialNumber: "Seriennummer",
    ElectricalLoad: "Elektrische Last",

    Category: "Kategorie",
    EfficiencyImprovement: "Effizienzsteigerung",
    CostSavingsPerYear: "Gesamte Kosteneinsparungen pro Jahr",
    ROI: "Kapitalrendite (ROI)",
    PaybackPeriod: "Dynamische Amortisationszeit",
    SimplePayback: "Statische Amortisationszeit",

    Estimated: "Geschätzt",
    Actual: "Ist",

    Like: "Gefällt mir",
    Dislike: "Gefällt mir nicht",

    OptionDetails: "Optionsdetails",
    TotalEnergySavings: "Gesamte Energieeinsparungen pro Jahr",
    RetrofitCost: "Modernisierungskosten",
    ExpectedYears: "Lebenszyklusdauer der Anlage",
    NPV: "Kapitalwert",

    ProjectIntroduction: "Projektvorstellung",
    Assumptions: "Annahmen",
    AssumptionsConsider: "Für die Analyse berücksichtigte Annahmen",
    AssumptionsAnalysis: "Annahmen für die Analyse",

    ChillerPlant: "Kältezentrale",
    Configuration: "Konfiguration",
    PeakBuildingLoad: "Maximale Gebäudekühllast",
    OAT: "Außenlufttemperatur",
    EnergyConservationMeasures: "Energieeinsparmaßnahmen",

    DesignFlowRate: "Auslegungsvolumenstrom",
    RatedDesignFlowRate: "Nennvolumenstrom (Auslegungsvolumenstrom)",
    DesignPressureHead: "Auslegungsförderhöhe",
    PressureHead: "Förderhöhe",
    VFDFitted: "Mit Frequenzumrichter ausgestattet",

    DesignConditions: "Auslegungsbedingungen",
    ProjectSettings: "Projekteinstellungen",

    Tariff: "Tarif",
    EnergyTariff: "Energietarif",
    MonthlyTariff: "Monatlicher Tarif",
    OperatingPeriod: "Betriebszeitraum",
    RunningMonths: "Betriebsmonate",

    Recommendation: "Empfehlung",
    Benefit: "Nutzen",

    MonthlyRunningDays: "Betriebstage ({type})",
    BaselineMonth: "Referenzmonat",
    EstimatedMonth: "Geschätzter Monat",
    EstimatedPower: "Geschätzte Leistungsaufnahme",
    ElectricityCarbonIntensity: "CO₂-Emissionsfaktor des Stroms",
    PlantEfficiency: "Anlagenwirkungsgrad",
    EfficienctyUnit: "Effizienz-Einheit",

    Type: "Typ",
    SellingPricePrtUnit: "Verkaufspreis je Gerät",
    ApplicableChiller: "Geeigneter Flüssigkeitskühler",
    NoOfFansCT: "Anzahl der Ventilatoren je Kühlturm",

    Load: "Last",
    Power: "Leistungsaufnahme",
    InputPower: "Leistungsaufnahme",

    TotalEnergyImprovement: "Gesamte energetische Verbesserung",
    EquipmentStatus: "Gerätestatus",

    SetRecommended: "Als empfohlen festlegen",
    CancelRecommendation: "Empfehlung zurücknehmen",

    Optional: "Optional",

    RetrofitCostConfiguration: "Konfiguration der Modernisierungskosten",
    PaybackPeriodSummaryNPV: "Übersicht über Amortisationszeit und Kapitalwert (NPV)",

    EquipmentDetailsProposed: "Details der vorgeschlagenen Geräte",
    GenerateECMReport: "ECM-Bericht erstellen",

    PeakMaxCoolingLoad: "Maximale Kühllast während der Hochtarifzeit",
    OffPeakMaxCoolingLoad: "Maximale Kühllast während der Niedertarifzeit",

    ProposedCoolingCapacity: "Vorgeschlagene Kälteleistung des Flüssigkeitskühlers",

    ChillerPlantTotal: "Kältezentrale gesamt",

    EnergySavingsPerYear: "Energieeinsparungen pro Jahr",

    CapitalAssetRetrofitInvestmentCost: "Investitionskosten für die Modernisierung des Anlagevermögens",
    EstimatedProjectValue: "Geschätzter Projektwert",
    ActualProjectValue: "Tatsächlicher Projektwert",

    ProjectDetails: "Eingabedetails",

    ElectricalDB: "Elektrische Unterverteilung",
    PlantControlSys: "Anlagenleitsystem",

    QuickSelect: "Schnellauswahl",
    ClusterMonth: "Gruppierte Monate",

    MonthlyCoolingLoad: "Monatliche Kühllast",
    MonthlyPower: "Monatliche Leistungsaufnahme",

    Default: "Standard",
    ReconfigureSolution: "Lösung neu konfigurieren",
    ReconfiguredSolution: "Neu konfigurierte Lösung",

    SingleChilledWaterTemp: "Einheitliche Kaltwassertemperatur",
    ECatPerformanceData: "e-CAT Leistungsdaten",
    CopyInputECATPerformance: "eCAT-Daten übernehmen",

    CopyFrom: "Kopieren von",
    PasteInto: "Einfügen in",

    PredictedUtilization: "Prognostizierte Auslastung",
    UserConfirmedUtilization: "Vom Benutzer bestätigte Auslastung",

    ProjectObjective: "Projektziel",
    ChillerEfficiency: "Kältemaschinen-Effizienz",
    ChillerPlantEfficiency: "Anlageneffizienz (Kältezentrale)",
    HeatingEfficiency: "Heizeffizienz",
    HeatingPlantEfficiency: "Heizanlagen-Effizienz",
    ChillerHeatingEfficiency: "Kälte- & Heizeffizienz",
    ChillerRetrofit: "Modernisierung des Flüssigkeitskühlers",
    ChillerPlantRetrofit: "Modernisierung der Kältezentrale",
    HeatingElectricRetrofit: "HeatingElectricRetrofit",
    HeatPumpRetrofit: "Wärmepumpen-Modernisierung",
    IntegratedRetrofit: "Modernisierung der integrierten Kälte- und Wärmezentrale",

    ManualInput: "Manuelle Eingabe",
    AutoSoon: "Automatik in Kürze verfügbar",

    AvailableDesignTemp: "Verfügbare Auslegungstemperatur",
    ChillerSelection: "Flüssigkeitskühlerauswahl",
    NewChillerSeries: "Neue Flüssigkeitskühlerbaureihe",
    ECATLibraryType: "e-CAT Bibliothekstyp",
    PerformanceTable: "Leistungstabelle",
    ChillerName: "Name des Flüssigkeitskühlers",
    StandardECAT: "Standard-e-CAT",
    EstimatedECAT: "Geschätzte eCAT-Leistungsdaten",
    CustomizedECAT: "Benutzerdefinierter eCAT",
    CustomCapacity: "Benutzerdefinierte Leistung",

    OperatingDayType: "Betriebstagtyp",
    MonthlyOperatingDays: "Monatliche Betriebstage",
    OperatingSiteChiller: "Am Standort betriebener Flüssigkeitskühler",
    ProxyChillerModel: "Flüssigkeitskühler-Ersatzmodell",
    ManufacturingRegion: "Produktionsregion",
    CompressorType: "Verdichtertyp",
    BearingType: "Lagertyp",
    VFDType: "Frequenzumrichtertyp",
    AvailableProxyModels: "Verfügbare Ersatzmodelle",
    NominalCapacity: "Nennleistung",
    PointsCalibration_4: "4-Punkt-Kalibrierung",
    PartLoadCalibration_note: "Für die Teillastkalibrierung werden ausschließlich Werksdaten unter Auslegungsbedingungen unterstützt.",

    HourlyChillerOperation: "Stündlicher Betrieb des Flüssigkeitskühlers",
    OperatingChillerCount: "Anzahl betriebener Flüssigkeitskühler",
    LoadRatio: "Lastanteil",
    CalculatedOperatingLoad: "Berechnete Betriebslast",

    NewChillerType: "Neuer Flüssigkeitskühlertyp",

    ProposedEfficiency: "Wirkungsgrad der vorgeschlagenen Lösung",
    RetrofitConfiguration: "Modernisierungskonfiguration",
    ROI_NPVSummary: "Übersicht über ROI und Kapitalwert (NPV)",
    AssumptionOfferings: "Annahmen und Angebote",

    ProposedRunningNumber: "Vorgeschlagene Anzahl betriebener Geräte",

    ProposedSummary: "Zusammenfassung der vorgeschlagenen Lösung",
    BaselineEfficiency: "Effizienz der Ausgangsbasis",
    AnnualizedAverageROI: "NPV-basierter Ø Jahres-ROI",

    SelectProposedScenarios: "Vorgeschlagene Szenarien auswählen",
    BaselineHourlyCoolingLoad: "Stündliche Kühllast der Ausgangsbasis",

    ProxyChillerFilter: "Filter für Flüssigkeitskühler-Ersatzmodelle",

    ChillerEfficiency_100: "Effizienz des Flüssigkeitskühlers bei 100 % Last",
    DegradedEfficiency_100: "Wirkungsgrad bei 100 % Last unter Berücksichtigung der Degradation",

    CommercialInput: "Kaufmännische Eingaben",

    SiteSettings: "Standorteinstellungen",
    ExistingBoilerSystem: "Bestehendes Heizkesselsystem",
    HeatingApplication: "Heizungsanwendung",

    PerformanceModel: "Leistungsmodell",
    HeatingCapacityPerUnit: "Nennheizleistung je Gerät",
    BaselineSetup: "Einrichtung der Ausgangsbasis",
    OperatingMonths: "Betriebsmonate",
    OperatingBoiler: "Betriebener Heizkessel",
    BoilerNumAtColdest: "Anzahl betriebener Heizkessel bei niedrigster Temperatur",
    singlePriceNote: "Dient zur Schätzung der Investitionsausgaben (CAPEX) des Projekts einschließlich Installation.",

    BoilerDetails: "Heizkesseldetails",
    HeatPumpCfg: "Wärmepumpenkonfiguration",
    HeatPumpSourceType: "Art der Wärmepumpenquelle",
    HotWaterSupplyTemp: "Heizwassereintrittstemperatur",
    ActualHWSTemp: "Ist-Warmwassereintrittstemperatur",
    SingleHWSTemp: "Einheitliche Heizwassereintrittstemperatur",
    WaterSourceTemp: "Temperatur der Wärmequelle Wasser",
    GroundLoop: "Erdwärmekreislauf",
    HeatingCapacity: "Heizleistung",
    RatedHeatingCapacity: "Nennheizleistung",
    HeatPumpSelection: "Wärmepumpenauswahl",
    HeatPumpName: "Name der Wärmepumpe",
    HeatPumpModel: "Wärmepumpenmodell",
    ModelNumber: "Modellnummer",
    AirSourceTemp: "Lufttemperatur (Wärmequelle)",
    DesignAirSourceTemp: "Auslegungstemperatur der Luftwärmequelle",
    DesignEWSTemp: "Auslegungs-Wassereintrittstemperatur am Verdampfer",
    RatedCOP_100: "Nenn-COP bei 100 % Last",

    ProposedHeatPumpCOP: "COP der vorgeschlagenen Wärmepumpe",
    MaxHeatingLoad: "Maximale Heizlast",
    ProposedHeatPumpCapacity: "Vorgeschlagene Wärmepumpenleistung je Gerät",
    CostAssumptionInputs: "Eingaben zu Kosten und Annahmen",
    ExistingAnnualCost: "Bestehende jährliche Kosten",
    ProposedAnnualCost: "Jährliche Kosten der vorgeschlagenen Lösung",
    Escalation: "Preissteigerung"
  },

  option: {
    New: "Neu",
    Existing: "Bestand",
    Remove: "Entfernen",

    LARGE_OFFICE: "Großes Bürogebäude",
    MEDIUM_OFFICE: "Mittelgroßes Bürogebäude",
    SMALL_OFFICE: "Kleines Bürogebäude",
    RESTAURANT: "Restaurant",
    HOSPITAL: "Krankenhaus",
    HOTEL: "Hotel",
    MALL: "Einkaufszentrum",
    SCHOOL: "Schule",
    EDUCATIONAL_INSTITUTIONS: "Bildungseinrichtungen",
    RESIDENTIAL: "Wohngebäude",
    OTHERS: "Sonstige",

    Month: "Monat",
    Jan: "Jan.",
    Feb: "Feb.",
    Mar: "März",
    Apr: "Apr.",
    May: "Mai",
    Jun: "Juni",
    Jul: "Juli",
    Aug: "Aug.",
    Sep: "Sept.",
    Oct: "Okt.",
    Nov: "Nov.",
    Dec: "Dez.",

    plant: "Kältezentrale",
    chiller: "Flüssigkeitskühler",
    pump: "Pumpe",
    coolingTower: "Kühlturm",
    piping: "Rohrleitungen",
    dryCooler: "Trockenrückkühler",
    controlSys: "Regelungssystem",
    boiler: "Heizkessel",
    heatPump: "Wärmepumpe",
    other: "Sonstige",

    WaterCooled: "Wassergekühlt",
    AirCooled: "Luftgekühlt",
    WaterCooled_AirCooled: "Wassergekühlt und luftgekühlt",

    chwp: "Kaltwasserpumpe",
    chwpPrimary: "Kaltwasserpumpe – Primärpumpe",
    chwpSecondary: "Kaltwasserpumpe – Sekundärpumpe",
    PrimaryPump: "Primärpumpe",
    SecondaryPump: "Sekundärpumpe",
    cwp: "Kühlwasserpumpe des Verflüssigers",
    CondenserWater: "Kühlwasser des Verflüssigers",
    ChilledWaterPrimary: "Kaltwasser-Primärsystem",
    ChilledWaterPrimarySecondary: "Kaltwasser-Primär-/Sekundärsystem",
    CondenserWaterSys: "Kühlwassersystem des Verflüssigers",
    CommonHeader: "Gemeinsame Sammelleitung",
    Dedicated_1_1: "Feste 1:1-Zuordnung",

    wcCentri: "Wassergekühlt – Turboverdichter",
    wcScrew: "Wassergekühlt – Schraubenverdichter",
    wcRecip: "Wassergekühlt – Hubkolbenverdichter",
    wcScroll: "Wassergekühlt – Scrollverdichter",
    acScrew: "Luftgekühlt – Schraubenverdichter",
    acScroll: "Luftgekühlt – Scrollverdichter",
    acRecip: "Luftgekühlt – Hubkolbenverdichter",

    Centrifugal: "Turboverdichter",
    Screw: "Schraubenverdichter",
    Scroll: "Scrollverdichter",
    Reciprocating: "Hubkolbenverdichter",
    Rotary: "Rotierend",

    Degradation_25: "0,25 % pro Jahr",
    Degradation_50: "0,50 % pro Jahr",
    Degradation_75: "0,75 % pro Jahr",
    Degradation_100: "1,00 % pro Jahr",

    GoodCondition: "Guter Zustand",
    AverageCondition: "Durchschnittlicher Zustand",
    BelowAverageCondition: "Unterdurchschnittlicher Zustand",
    BadCondition: "Schlechter Zustand",

    SpaceCooling: "Raumkühlung",
    SpaceHeating: "Raumheizung",
    DomesticHotWater: "Trinkwarmwasser",
    SHandDHW: "Raumheizung und Trinkwassererwärmung",

    GasFuel: "Gasförmiger Brennstoff",
    LiquidFuel: "Flüssiger Brennstoff",
    ElectricalEnergy: "Elektrische Energie",

    DryBulbTemp: "Mittlere Trockenkugeltemperatur",
    WetBulbTemp: "Mittlere Feuchtkugeltemperatur",
    WaterTemp: "Wassertemperatur",

    MaxDryBulbTemp: "Mittlere maximale Trockenkugeltemperatur",
    MinDryBulbTemp: "Mittlere minimale Trockenkugeltemperatur",
    AvgDryBulbTemp: "Mittlere Trockenkugeltemperatur",
    MaxWetBulbTemp: "Mittlere maximale Feuchtkugeltemperatur",
    MinWetBulbTemp: "Mittlere minimale Feuchtkugeltemperatur",
    AvgWetBulbTemp: "Mittlere Feuchtkugeltemperatur",

    PeakWaterTemp: "Wassertemperatur während der Hochtarifzeit",
    OffPeakWaterTemp: "Wassertemperatur während der Niedertarifzeit",
    AvgTemp: "Mittlere Temperatur",

    ColdWaterTemp: "Kaltwassereintrittstemperatur",

    CondenserWaterSupplyTemp: "Kühlwassereintrittstemperatur am Verflüssiger",
    MeanCondenserWaterSupplyTemp: "Mittlere Kühlwassereintrittstemperatur am Verflüssiger",
    MeanMaxCWSTemp: "Mittlere maximale Kühlwassereintrittstemperatur am Verflüssiger",
    MeanAvgCWSTemp: "Mittlere durchschnittliche Kühlwassereintrittstemperatur am Verflüssiger",

    CondenserAirSupplyTemp: "Lufteintrittstemperatur am Verflüssiger",
    MeanCondenserAirSupplyTemp: "Mittlere Lufteintrittstemperatur am Verflüssiger",
    MeanMaxCASTemp: "Mittlere maximale Lufteintrittstemperatur am Verflüssiger",
    MeanAvgCASTemp: "Mittlere durchschnittliche Lufteintrittstemperatur am Verflüssiger",

    PathA: "Auf Basis der Kühllast",
    PathB: "Auf Basis des Energieverbrauchs",
    Method1: "Stundenprofil für 1 Monat",
    Method3: "Stundenprofil für 12 Monate",

    HeatingPathA: "Ansatz ausschließlich auf Basis der Heizkesselleistung",
    HeatingPathB: "Heizkesselleistung mit Einbeziehung von Energiedaten",

    Off: "Aus",
    Peak: "Hochtarifzeit",
    OffPeak: "Niedertarifzeit",
    AllPeak: "Durchgehend Hochtarifzeit",
    PeakPeriod: "Hochtarifzeitraum",
    OffPeakPeriod: "Niedertarifzeitraum",
    WeekdayPeak: "Wochentag – Hochtarifzeit",
    WeekdayOffPeak: "Wochentag – Niedertarifzeit",
    WeekendPeak: "Wochenende – Hochtarifzeit",
    WeekendOffPeak: "Wochenende – Niedertarifzeit",

    AllCity: "Alle Städte",
    MegaCity: "Megastadt",
    NonMegaCity: "Keine Megastadt",

    Win: "Gewonnen",
    PipeLine: "Pipeline",
    TotalPipeline: "Gesamte Pipeline",
    ActualOrder: "Tatsächlicher Auftrag",
    ExpectedOrder: "Erwarteter Auftrag",

    All: "Alle",
    Values: "Werte",
    Projects: "Projekte",
    Count: "Anzahl",
    WinProbability: "Abschlusswahrscheinlichkeit",

    SingleCluster: "Eine Gruppe",
    MultipleCLuster: "Mehrere Gruppen",

    HighestEfficiencyImprovement: "Höchste Wirkungsgradsteigerung",
    LowestInvestment: "Niedrigste Investition",
    ShortestPaybackPeriod: "Kürzeste Amortisationszeit",

    Max: "Maximum",
    Min: "Minimum",
    Avg: "Mittelwert",

    StepMonthlyCoolingLoad: "Monatliche Kühllast",
    StepEstimateCoolingLoad: "Kühllast schätzen",
    StepEstimatePower: "Leistungsaufnahme der Flüssigkeitskühler schätzen",
    StepEstimatePowerLoad: "Leistungsaufnahme der Flüssigkeitskühler schätzen",
    EstimateChillerCount: "Anzahl der Flüssigkeitskühler schätzen",

    OperatingCalendar: "Betriebskalender",
    OperatingHours: "Betriebsstunden",
    OperatingLoad: "Betriebslast",
    ReferChiller: "Referenz-Flüssigkeitskühler",
    MonthlyChillerCount: "Monatliche Anzahl der Flüssigkeitskühler",

    RunningHours: "Betriebsstunden",
    EnergyConsumption: "Energieverbrauch",
    ChillerEnergyConsumption: "Energieverbrauch der Flüssigkeitskühler",

    AuxiliaryPower: "Leistungsaufnahme der Nebenaggregate",
    PlantEquipment: "Anlagengeräte",
    ChillerPower: "Leistungsaufnahme des Flüssigkeitskühlers",
    CHWPPower: "Leistungsaufnahme der Kaltwasserpumpe",
    CWPPower: "Leistungsaufnahme der Kühlwasserpumpe des Verflüssigers",
    CTPower: "Leistungsaufnahme des Kühlturms",

    WeightedAvgEfficiency: "Gewichteter mittlerer Wirkungsgrad",
    WeightedAvgCoolingLoad: "Gewichtete mittlere Kühllast",
    WeightAvgPower: "Gewichtete mittlere Leistungsaufnahme",
    RunningHrsPerDay: "Betriebsstunden pro Tag",
    ActualWeightedAveragePower: "Tatsächliche gewichtete mittlere Leistungsaufnahme",

    AnnualCost: "Jährliche Kosten",
    AnnualEscalation: "Jährliche Kostensteigerung",
    IncentiveRebate: "Förderung und Zuschuss",

    ProposeConfig: "Vorgeschlagene Konfiguration",

    Weekday: "Wochentag",
    Weekend: "Wochenende",
    WholeWeek: "Gesamte Woche",

    Automatic: "Automatisch",
    Manual: "Manuell",
    Reconfigured: "Neu konfiguriert",
    AlgorithmSelectsConfig: "Algorithmus wählt Konfiguration aus",
    UserSelectsConfig: "Benutzer wählt Konfiguration aus",

    ManualCluster: "Manuelle Gruppierung",
    DigitalECAT: "Digitaler e-CAT",

    BoilerUtilization: "Heizkesselauslastung",
    HeatingLoad: "Heizlast",
    MonthlyHeatingLoad: "Monatliche Heizlast",
    EffectiveMonthly: "Effektive monatliche Heizenergie",
    EnergyCharges: "Energiekosten",
    CO2Emissions: "CO₂-Emissionen",
    GasFuelConsumption: "Verbrauch an gasförmigem Brennstoff",
    LiquidFuelConsumption: "Verbrauch an flüssigem Brennstoff",
    ElectricalEnergyConsumption: "Stromverbrauch",
    GasFuelCharges: "Kosten für gasförmigen Brennstoff",
    LiquidFuelCharges: "Kosten für flüssigen Brennstoff",
    ElectricalEnergyCharges: "Stromkosten",

    Standard: "Standard",
    Ceramic: "Keramik",
    Magnetic: "Magnetisch",
    VFD: "Frequenzumrichter (VFD)",
    NonVFD: "Ohne Frequenzumrichter",
    ClusterMonths: "Gruppierte Monate",

    Chiller: "Flüssigkeitskühler",
    HeatPump: "Wärmepumpe",
    WaterSource: "Wasser als Wärmequelle",
    AirSource: "Luft als Wärmequelle",

    ConstantEfficiency: "Konstanter Wirkungsgrad",
    UserDefinedCurve: "Benutzerdefinierte Kennlinie",
    BoilerOperation: "Heizkesselbetrieb",
    MonthlyEnergyConsumption: "Monatlicher Energieverbrauch",
    AvgHeatingLoad: "Gewichtete mittlere Heizlast",
    MonthlyBoilerCount: "Monatliche Anzahl der Heizkessel",
    BoilerEnergyConsumption: "Energieverbrauch des Heizkessels",
    EstimateBoilerCount: "Anzahl der Heizkessel schätzen",
    EstimateHeatingLoad: "Heizlast schätzen",
    EstimateEnergyConsumption: "Energieverbrauch schätzen",

    ECatLib: "e-CAT-Bibliothek",
    OwnLib: "Benutzerbibliothek"
  },

  msg: {
    imageOnly: "Nur Bilddateien sind erlaubt",
    comingSoon: "In Kürze verfügbar.",
    Success: "Erfolgreich",
    FailedRetry: "Fehlgeschlagen! Bitte versuchen Sie es erneut",
    DeleteEquip: "Gerät löschen",
    DeleteWarning: "Möchten Sie Folgendes wirklich löschen: ",
    DeleteBaseline: "Ausgangsbasis löschen",
    Warning: "Warnung",
    UnsavedWarning: "Nicht gespeicherte Änderungen gehen verloren, wenn Sie die aktuelle Seite verlassen.",
    SaveBeforeProceeding: "Möchten Sie Ihre Änderungen speichern, bevor Sie fortfahren?",
    NoOptionsSelected: "Keine Optionen ausgewählt",
    AlreadyExists: "Bereits vorhanden",
    Saving: "Wird gespeichert...",
    Generating: "Wird erstellt...",
    Loading: "Wird geladen...",
    DeletingFiles: "Dateien werden gelöscht...",
    CompressingFiles: "Dateien werden komprimiert...",
    UnsupportedImageTypeTitle: "Nicht unterstützte Dateien übersprungen",
    UnsupportedImageTypesDiscarded: "Übersprungene Dateitypen",
    UploadingFiles: "Dateien werden hochgeladen...",
    NetworkError: "Netzwerkstörung, Vorgang fehlgeschlagen",
    NetworkLimit: "Netzanomalie, Funktion eingeschränkt",
    Over24HoursTips: "Gesamtzeit überschreitet 24 Stunden",
    Over24HoursToast: "Gesamtdauer der Hoch- und Niedertarifzeiten überschreitet 24 Stunden",
    CityChanged: "Die Stadt wurde von {curtCity} in {newCity} geändert.",
    OverrideWeatherData: "<br>Möchten Sie die vorhandenen Wetterprofildaten mit den Außenlufttemperaturdaten (OAT) der neu ausgewählten Stadt überschreiben?",
    ProjectNameIsEmpty: "Der Projektname darf nicht leer sein",
    CityIsEmpty: "Die Stadt darf nicht leer sein",
    SelectReferModel: "Bitte wählen Sie ein Referenzmodell aus",
    InputDataIntoReferenceChiller: "Die oben stehenden Daten in den Referenz-Flüssigkeitskühler übernehmen",
    PeriodCanNotAllOff: "Es dürfen nicht alle Zeiträume auf Aus stehen",
    CanNotBlank: "Darf nicht leer sein",
    CanNotBlankZero: "Darf nicht leer oder 0 sein",
    CanNotAllBlank: "Es dürfen nicht alle Felder leer sein",
    CanNotAllBlankZero: "Die Felder dürfen nicht alle leer oder alle 0 sein",
    NetworkTimeout: "Zeitüberschreitung im Netzwerk! Bitte versuchen Sie es erneut",
    RequestError: "Anfragefehler",
    LoginExpired: "Anmeldesitzung abgelaufen",
    AccessDenied: "Zugriff verweigert",
    ResourceNotExist: "Die angeforderte Ressource ist nicht vorhanden",
    ServerError: "Dienstfehler",
    GatewayError: "Gateway-Fehler",
    ServiceUnavailable: "Dienst nicht verfügbar",
    UserNotExist: "Benutzer ist nicht vorhanden",
    WrongPassword: "Falsches Passwort",
    NotActivate: "Konto nicht aktiviert",
    DeleteCluster: "Gruppe löschen",
    Estimating: "Schätzung läuft...",
    Analyzing: "Analyse läuft...",
    Calculating: "Berechnung läuft...",
    UnsavedAfterEstimate: "Nicht gespeicherte Daten, die nach der letzten Schätzung eingegeben wurden, gehen verloren, wenn Sie diese Seite verlassen.",
    DiscountRateTips: "Der Kalkulationszinssatz bestimmt die erwartete Investitionsrendite; ist keiner angegeben, wird die Inflationsrate verwendet.",
    CalculateROINotice: "Bitte klicken Sie zuerst auf '1. Eingabe', um die Modernisierungskosten zu vervollständigen, und anschließend auf 'ROI berechnen'.",
    ConfirmFxRate: "Bitte bestätigen Sie den USD-Wechselkurs",
    SetRecommended: "{name} als empfohlen festlegen",
    SelectCardPasteInto: "Bitte wählen Sie die Karte aus, in die eingefügt werden soll.",
    Copied: "In die Zwischenablage kopiert",
    Pasted: "Eingefügt",
    OverwriteOption: "Bei erneuter Erstellung werden alle vorhandenen Lösungsdaten überschrieben und der erstellte Bericht entfernt.",
    OverwriteOptionAll: "Sie haben eine optimierte Lösung konfiguriert. <br/>Bei erneuter Erstellung werden alle vorhandenen Lösungsdaten überschrieben und der erstellte Bericht entfernt.",
    RefreshRequired: "Aktualisierung erforderlich",
    ReAnalysisPre:
      "Um die Vorschau der Ausgangsbasis zu erstellen oder zu aktualisieren, aktualisieren Sie zuerst die Kühllast- und Leistungsaufnahmeanalyse unter Monatliche Ausgangsbasis und anschließend die Vorschau der Ausgangsbasis manuell.",
    ReAnalysisHeating:
      "Um die Vorschau der Ausgangsbasis zu erstellen oder zu aktualisieren, aktualisieren Sie zuerst die Heizlast- und Leistungsaufnahmeanalyse unter Monatliche Ausgangsbasis und anschließend die Vorschau der Ausgangsbasis manuell.",

    PleaseSelectObjective: "Bitte wählen Sie eine Zielsetzung aus",
    HeatingOnlySupportsPre: "Das Modul zum Heizungswirkungsgrad unterstützt derzeit nur den Zustand vor der Modernisierung",
    CompleteBaselineConfigFirst: "Bitte schließen Sie zuerst die Konfiguration der Ausgangsbasis im Bereich vor der Modernisierung ab.",
    CompleteBaselineAnalysisFirst: "Bitte schließen Sie zuerst die Analyse der Ausgangsbasis im Bereich vor der Modernisierung ab",

    AcceptOneUtilization: "Prognostizierte Auslastung als vom Benutzer bestätigte Auslastung übernehmen?",
    AcceptAllUtilization: "Alle prognostizierten Auslastungen als vom Benutzer bestätigte Auslastungen übernehmen?",
    NoReportGenerate: "Kein Bericht vorhanden. Bitte öffnen Sie das Projekt, um einen Bericht zu erstellen.",

    DependencyHint: "Hinweis zu Abhängigkeiten:",
    DryBulbDependencyCooling: "Die Trockenkugeltemperatur dient zur Schätzung des Kühllastprofils.",
    WeatherDependencyCooling:
      "Bei wassergekühlten Flüssigkeitskühlern wird die Kühlwassereintrittstemperatur am Verflüssiger zur Schätzung der Leistungsaufnahme des Flüssigkeitskühlers verwendet. Bei luftgekühlten Flüssigkeitskühlern wird stattdessen die Trockenkugeltemperatur verwendet.",

    DryBulbDependencyHeating:
      "Die Trockenkugeltemperatur dient zur Schätzung des Raumheizlastprofils, während die Kaltwassereintrittstemperatur zur Schätzung des Lastprofils der Trinkwassererwärmung verwendet wird.",
    WeatherDependencyHeating: "Die oben angezeigten Wetterparameter hängen von der ausgewählten Heizungsanwendung ab.",

    CalibrationTitle: "Unvollständige 4-Punkt-Kalibrierungsdaten",
    CalibrationNote:
      "Die 4-Punkt-Kalibrierungsdaten für den Referenz-Flüssigkeitskühler sind unvollständig. Geben Sie Werte für alle vier Lastpunkte (25 %, 50 %, 75 % und 100 %) ein oder deaktivieren Sie die 4-Punkt-Kalibrierung, um fortzufahren.",
    CalibrationBack: "Zurück zum Referenz-Flüssigkeitskühler",

    SelectReportingFocus: "Schwerpunkt des Kundenberichts auswählen",
    ROILedSummary: "ROI-orientierte Zusammenfassung",
    EfficiencyLedSummary: "Zusammenfassung mit Fokus auf Effizienzsteigerung",
    ROILedNote: "Verwenden, wenn Investition, Einsparungen und Amortisationsergebnisse ausreichen, um das Projekt zu rechtfertigen.",
    EfficiencyLedNote: "Verwenden, wenn die Effizienzsteigerung die Hauptrechtfertigung ist, unabhängig von der Attraktivität der Amortisation.",
    ROILedNote_C: "Verwenden, wenn Investitionskosten, Einsparungen und Amortisationszeit verfügbar sind.",
    EfficiencyLedNote_C: "Verwenden, wenn die Entscheidungsfindung hauptsächlich auf Energieeffizienz basiert oder ROI-Daten nicht verfügbar bzw. nicht aussagekräftig sind.",

    ImgIgnoredWhenOffline: "Bildoperationen werden ignoriert, wenn offline"
  },

  placeholder: {
    PleaseInput: "Bitte eingeben",
    SearchHere: "Hier suchen",
    PleaseSelect: "Bitte auswählen",
    SearchFilter: "Suchen und Filtern",
    NotAvailable: "Nicht verfügbar",
    NoDataExist: "Keine Daten vorhanden",
    NoDataAvailable: "Keine Daten verfügbar",
    NoChillerExist: "Keine Flüssigkeitskühlerdaten vorhanden",
    NoBaselineExist: "Keine Daten zur Ausgangsbasis vorhanden",
    ClusterAutomaticallyMatches: "Ordnet automatisch alle Betriebszeiträume zu",
    NoClusterExist: "Keine Monatsgruppen vorhanden. Bitte legen Sie zuerst Monatsgruppen fest",
    SelectTempCluster: "Bitte wählen Sie die Gruppentemperatur aus",
    PleaseSelectInputFormat: "Bitte auswählen oder eingeben, Format: ",
    SearchFormat: "Hier suchen, Format: ",
    DigitalECatNotify: "Die digitalen e-CAT-Daten werden derzeit integriert. Bitte verwenden Sie vorerst die manuelle Gruppierung.",

    AssumptionsPlaceholder:
      "Bitte erläutern Sie die Annahmen für die Analyse. Geben Sie die berücksichtigten Witterungsbedingungen, das monatliche Betriebsprofil der Geräte und die im Gespräch bereitgestellten Kundendaten an. Alternativ können Sie die Schaltfläche Vorlage für die Standardbeschreibung verwenden.",
    AssumptionsTemp:
      "Vorlage für die Analyseannahmen: Die Analyse basiert auf [Energieverbrauchsdaten des Flüssigkeitskühlers / Kühllastdaten], die anhand von Betriebsgesprächen geschätzt wurden. Diese Daten dienen zur Schätzung des monatlichen Teillastverhaltens des vorhandenen Flüssigkeitskühlers [Flüssigkeitskühlermodell eingeben], indem sie mit lokalen historischen Wetterdaten des entsprechenden Zeitraums korreliert werden.\n\n(Optional: Verwenden, wenn der Energieverbrauch der Flüssigkeitskühler als Anteil des gesamten Gebäudeenergieverbrauchs angegeben wird)\nEnergieanteil der Flüssigkeitskühler:\nFür den Energieverbrauch der Kältezentrale wird ein Anteil von [Prozentsatz eingeben, z. B. 45 %] am gesamten Gebäudeenergieverbrauch angenommen.\n\nDie folgenden Betriebsparameter wurden mit dem Team des Kunden bestätigt und verwendet:\nBetriebsplan der Flüssigkeitskühler:\n[Anzahl] Flüssigkeitskühler werden von [Monat] bis [Monat] betrieben\n[Anzahl] Flüssigkeitskühler werden von [Monat] bis [Monat] betrieben",

    ObservationNote: "Behalten Sie nur die zutreffenden Optionen in eckigen Klammern bei und überprüfen Sie vor dem Speichern sämtliche Standortangaben.",
    Observation_chiller:
      "Der vorhandene Flüssigkeitskühler zeigt Alterungserscheinungen und einen verringerten Wirkungsgrad. Die Betriebsaufzeichnungen weisen auf [häufige Alarme / hohe Leistungsaufnahme / instabilen Betrieb / zunehmenden Wartungsbedarf] hin, insbesondere unter [Teillast- / Spitzenlast-]Bedingungen.",
    Recommendation_chiller:
      "Führen Sie einen ausführlichen Leistungstest durch und überprüfen Sie Betriebssollwerte, Kältemittelzustand, Wärmeübertragungsflächen und Regelungen. Optimieren Sie je nach Ergebnis den Betrieb oder ersetzen Sie das Gerät durch einen hocheffizienten drehzahlgeregelten Flüssigkeitskühler.",
    Benefit_chiller:
      "Zu den erwarteten Vorteilen gehören ein geringerer Energieverbrauch der Flüssigkeitskühler, ein verbesserter Teillastwirkungsgrad, weniger ungeplante Ausfälle, geringere Wartungskosten und eine stabilere Kaltwasserversorgung. Ein hocheffizientes Ersatzgerät kann außerdem CO₂-Emissionen reduzieren und die langfristige Zuverlässigkeit der Anlage verbessern.",
    Observation_pump:
      "Die vorhandene [Kaltwasser- / Verflüssigerkühlwasser-]Pumpe arbeitet [mit fester Drehzahl / in einem ineffizienten Regelungspunkt]. Der Volumenstrom erscheint im Teillastbetrieb höher als erforderlich; außerdem wurden [Geräusche / Schwingungen / Leckagen / instabiler Druck] festgestellt.",
    Recommendation_pump:
      "Überprüfen Sie Pumpenbetriebspunkt, Volumenstrom, Förderhöhe, Ventilstellung und hydraulischen Abgleich. Nehmen Sie die Pumpe und die Regelungslogik erneut in Betrieb. Installieren oder aktivieren Sie nach Möglichkeit einen Frequenzumrichter und passen Sie die Pumpendrehzahl anhand des Differenzdrucks oder des tatsächlichen Anlagenbedarfs an.",
    Benefit_pump:
      "Die vorgeschlagene Maßnahme kann den Pumpenenergieverbrauch senken, überhöhte Volumenströme und Drosselverluste vermeiden, die Temperaturspreizung und hydraulische Stabilität des Systems verbessern und den mechanischen Verschleiß verringern. Ein bedarfsabhängiger Betrieb kann außerdem den Wartungsbedarf senken und den Gesamtwirkungsgrad der Kältezentrale verbessern.",
    Observation_coolingTower:
      "Der Kühlturm weist [einen hohen Kühlgrenzabstand / verschmutzte Füllkörper / eine ungleichmäßige Wasserverteilung / eine unzureichende Ventilatorregelung / sichtbare Kalkablagerungen] auf. Die Kühlwassertemperatur am Verflüssiger wird nicht durchgehend auf einem effizienten Niveau gehalten.",
    Recommendation_coolingTower:
      "Prüfen und reinigen Sie Füllkörper, Becken, Düsen, Schmutzfänger und Wärmeübertragungsflächen. Überprüfen Sie Wasseraufbereitung, Luftstrom und Ventilatorbetrieb. Optimieren Sie die Stufenschaltung und setzen Sie eine Frequenzumrichterregelung ein, um die erforderliche Kühlwassertemperatur am Verflüssiger einzuhalten.",
    Benefit_coolingTower:
      "Eine verbesserte Kühlturmleistung kann die Kühlwassertemperatur am Verflüssiger innerhalb sicherer Betriebsgrenzen senken, den Temperaturhub und Energieverbrauch der Flüssigkeitskühler reduzieren, den Anlagenbetrieb stabilisieren und das Risiko von Verkalkung oder Korrosion verringern. Eine optimierte Ventilatorregelung kann außerdem den Energieverbrauch des Kühlturms reduzieren und die Gerätelebensdauer verlängern.",
    Observation_controlSys:
      "Das bestehende Regelungssystem bietet hauptsächlich grundlegende Überwachungsfunktionen und optimiert das Zusammenspiel von Flüssigkeitskühlern, Pumpen und Kühltürmen nicht vollständig. Sollwerte und Gerätestufung sind [fest eingestellt / manuell angepasst / nicht auf die Last abgestimmt].",
    Recommendation_controlSys:
      "Modernisieren Sie das Anlagenleitsystem oder nehmen Sie es mit bedarfsabhängiger Schaltfolge, Sollwertanpassung, Gerätestufung, Alarmmanagement und Leistungsüberwachung erneut in Betrieb. Kalibrieren Sie die wesentlichen Temperatur-, Druck-, Volumenstrom- und Leistungssensoren.",
    Benefit_controlSys:
      "Eine koordinierte Anlagenregelung kann den Gesamtwirkungsgrad des Systems verbessern, indem Flüssigkeitskühler, Pumpen und Kühltürme als ein System betrieben werden. Sie kann unnötige Laufzeiten reduzieren, Temperaturen und Volumenströme stabilisieren, Störungen besser sichtbar machen und eine kontinuierliche Leistungsüberwachung und energetische Optimierung unterstützen.",
    Observation_dryCooler:
      "Der Trockenrückkühler weist [verschmutzte Wärmeübertrager / eingeschränkten Luftstrom / beschädigte Lamellen / eine hohe Fluidaustrittstemperatur / eine unzureichende Ventilatorregelung] auf. Die Ventilatoren laufen [mit fester Drehzahl / instabil], und die Wärmeabfuhrleistung erscheint unter [Teillast- / Spitzenlast-]Bedingungen unzureichend.",
    Recommendation_dryCooler:
      "Prüfen und reinigen Sie die Wärmeübertrager, richten Sie beschädigte Lamellen und beseitigen Sie Luftstromhindernisse. Überprüfen Sie Fluidvolumenstrom, Ventilatordrehrichtung, Sensoren und Regelungen. Optimieren Sie die Ventilatorstufung oder setzen Sie eine Frequenzumrichterregelung auf Basis der Fluidaustrittstemperatur und des Systembedarfs ein.",
    Benefit_dryCooler:
      "Eine verbesserte Trockenrückkühlerleistung kann die Fluidtemperatur senken, die Wärmeabfuhr des Systems verbessern und den Energieverbrauch von Ventilatoren und Flüssigkeitskühlern reduzieren. Eine optimierte Ventilatorregelung kann unnötige Laufzeiten und Geräusche verringern, während die regelmäßige Wartung der Wärmeübertrager dazu beiträgt, die Leistung zu erhalten, die Betriebsstabilität zu verbessern und die Gerätelebensdauer zu verlängern.",
    Observation_boiler:
      "Der vorhandene Heizkessel dient der [Raumheizung/Trinkwassererwärmung]. Der Heizkessel wird mit [Brennstoffart] betrieben und weist [hohen Brennstoffverbrauch/häufiges Takten/hohe Eintrittstemperatur am Heizkessel/ineffiziente Verbrennung/Leckagen] auf. Es wurde nur eine eingeschränkte Überwachung oder lastabhängige Optimierung festgestellt.",
    Recommendation_boiler:
      "Bewerten Sie Heizlast, Wassereintrittstemperatur an der Wärmepumpe, Betriebsplan und Anforderungen der Wärmeübergabegeräte. Prüfen Sie die Eignung einer Wärmepumpe und bestimmen Sie, ob der Heizkessel für den Spitzenlast- oder Reservebetrieb erhalten bleiben sollte.",
    Benefit_boiler:
      "Die Einbindung von Wärmepumpen kann Brennstoffverbrauch, CO₂-Emissionen und Betriebskosten senken und zugleich die erforderliche Heizleistung aufrechterhalten. Eine geeignete Lastanpassung verbessert den saisonalen Wirkungsgrad und kann die Abhängigkeit von der Verbrennung fossiler Brennstoffe verringern. Werden vorhandene Heizkessel nur für Spitzenlast- oder Reservebetrieb beibehalten, lässt sich das Modernisierungsrisiko minimieren und gleichzeitig die Dekarbonisierung unterstützen."
  },

  param: {
    hr: "Zeit",
    period: "Zeitraum",
    chCount: "Anzahl betriebener Flüssigkeitskühler",
    maxLoad: "Maximale Nennlast",
    percent: "Betriebslast",
    capacity: "Gesamte Betriebslast",
    consumption: "Energieverbrauch",
    existing: "Bestand",
    proposed: "Vorgeschlagene Lösung",
    assumptions: "Annahmen",
    energy: "Energie",
    maintenance: "Wartung",
    repair: "Reparatur",
    other: "Sonstige",
    discountRate: "Kalkulationszinssatz"
  },

  wizard: {
    navbar: {
      Wizard: "Assistent",
      MinimumInput: "Schnellsetup",
      GenerateDefaults: "Anfängliche Standardwerte generieren",
      ReviewAssumptions: "Annahmen prüfen",
      RunQuickCalculation: "Schnellberechnung ausführen",
      ProposedSolution: "Bewertungsergebnisse"
    },
    label: {
      ActualConditions: "Tatsächliche Bedingungen",
      MonthlyAverageTariff: "Monatlicher Durchschnittstarif",
      YearlyEnergyBill: "Jährliche Energierechnung",
      ReviewSection: "Prüfabschnitt",
      CoolingApplication: "Kühlungsanwendungstyp",
      TemperatureSensitivityFactor: "Temperatursensitivitätsfaktor"
    },
    option: {
      PROCESS_COOLING: "Prozesskühlung",
      DATA_CENTER: "Rechenzentrum",
      ComfortCooling: "Komfortkühlung",
      MixedUse: "Mischnutzung",
      ProcessDataCenter: "Prozesskühlung / Rechenzentrum",
      Custom: "Benutzerdefiniert"
    },
    msg: {
      GeneratingDefaults: "Standardwerte werden generiert...",
      RunningQuickCalculation: "Schnellberechnung wird ausgeführt...",
      DataOverwriteWarning: "Warnung vor dem Überschreiben von Daten",
      PendingResultChangesWarning: "Sie haben auf der Überprüfungsseite Änderungen vorgenommen. Bitte starten Sie die Erstellung neuer Ergebnisse, bevor Sie fortfahren.",
      RegenerateDefaultsWarning: "Wenn Sie die Standardwerte erneut generieren, werden die aktuellen Diagrammdaten auf der Prüfseite dauerhaft überschrieben. Möchten Sie fortfahren?",
      PeriodCanNotAllOffEveryBaseline: "Der Zeitraum darf nicht bei jeder Baseline vollständig ausgeschaltet sein."
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale/index/de.js